import { LogoWhatsappOutlineIc } from '@dsch/dd-icons';

import { RevealPhoneNumber } from '../../../../../../components/PageWrappers/SharedComponents/RevealPhoneNumber/RevealPhoneNumber';
import { RevealDealerEnquiryModal } from '../../../../../../components/PageWrappers/SharedComponents/RevealDealerEnquiryModal/RevealDealerEnquiryModal';
import { Loading } from '../../../../../../components/Toolkit/Loading/Loading';
import { DisplayContainer } from '../../../../../../components/Support/DisplayContainer/DisplayContainer';
import { Modal } from '../../../../../../components/ToolkitV2/Modal/Modal';
import { ModalHeader } from '../../../../../../components/ToolkitV2/Modal/subcomponents/ModalHeader';

import { useContactDealershipBottomSheet } from './ContactDealershipBottomSheet.hook';

import type { ContactDealershipBottomSheetProps } from '../../../../../../components/PageWrappers/AdDetails/components/ContactDealershipBottomSheet/ContactDealershipBottomSheet.typed';

import * as Styled from './ContactDealershipBottomSheet.styled';

import { CDN_STATIC_ASSETS } from '../../../../../../utils';
import { theme } from '../../../../../../helpers/Theme';
import { Spacer } from '../../../../../../helpers/genericStyles';
import { SELLER_TYPES } from '../../../types';

const ContactDealershipBottomSheet = (
  props: ContactDealershipBottomSheetProps,
) => {
  const {
    adId,
    phoneResponse,
    campaignId,
    emailResponse,
    sectionName,
    handleReveal,
    whatsappResponse,
    priceEuro,
    sellerType,
    price,
  } = props;

  const {
    onWhatsAppButtonClick,
    isContactSellerModalOpen,
    closeContactSellerModal,
    isLoading,
  } = useContactDealershipBottomSheet({
    adId,
    sectionName,
    price,
    priceEuro,
    sellerType,
  });

  return (
    <Modal
      isOpen={isContactSellerModalOpen}
      onRequestClose={closeContactSellerModal}
      modalClassName="contact-dealership"
      padding={theme.spacing.M24}
      left={0}
      right={0}
      bottom={0}
      top={null}
      offScreenTransform="translateX(0) translateY(100%)"
      onScreenTransform="translateX(0) translateY(0)"
      borderRadius={`${theme.borderRadius.default} ${theme.borderRadius.default} 0 0`}
      contentLabel="Contact Dealership"
    >
      <ModalHeader
        text="Contact Dealership"
        modalName="Contact Dealership"
        onRequestClose={closeContactSellerModal}
        weight="bold"
        size="L18"
        color="GREY_DARKER"
        forwardedAs="h2"
      />
      <Spacer marginBottom="M24" />
      <Styled.ButtonList>
        {phoneResponse && (
          <RevealPhoneNumber
            adId={adId}
            showNumberTextVariant={false}
            trackingId="reveal-number-gallery" // TODO: update
            clickSource="gallery"
            campaignId={campaignId}
            sectionName={sectionName}
            sellerType={SELLER_TYPES.DEALER}
            price={price}
          />
        )}
        {emailResponse && (
          <RevealDealerEnquiryModal
            adId={adId}
            id="dealer-enquiry-btn-gallery" // TODO: update
            text="Send Email"
            ofType="SECONDARY"
            handleReveal={handleReveal}
          />
        )}
        {whatsappResponse && (
          <DisplayContainer
            config={{ small: 'block', medium: 'none', large: 'none' }}
          >
            <Styled.WhatsAppButton
              ofType="SECONDARY"
              onClick={onWhatsAppButtonClick}
            >
              {isLoading ? (
                <Loading color="DARK" cdnUrl={CDN_STATIC_ASSETS} />
              ) : (
                <>
                  <LogoWhatsappOutlineIc
                    color={theme.colors.GREEN}
                    width={24}
                    height={24}
                  />{' '}
                  Chat on WhatsApp
                </>
              )}
            </Styled.WhatsAppButton>
          </DisplayContainer>
        )}
      </Styled.ButtonList>
    </Modal>
  );
};

export { ContactDealershipBottomSheet };
